export const MODAL_USER_NOT_LOGGED_IN = 'user_not_logged_in';
export const MODAL_INVALID_LAYER = 'invalid_layer';
export const MODAL_DATA_FAILED_TO_LOAD = 'failed_to_load';
export const MODAL_SAVE_LAYERS = 'modal_save_layers';
export const MODAL_SHARE_VIEW = 'modal_share_view';
export const MODAL_LOADING = 'modal_loading';
export const MODAL_COLLABORATORS = 'collaborators';
export const MODAL_LIMITS = 'modal_limits';
export const MODAL_HIDDEN_COLUMNS = 'modal_hidden_columns';
export const MODAL_ER_DIAGRAM = 'modal_er_diagram';
export const MODAL_SHARE_WITH_TEAM = 'modal_share_with_team';
export const MODAL_EXPORT_TO_SHEETS = 'modal_export_to_sheets';
export const MODAL_SHARE_AS_HTML = 'modal_share_as_html';
export const MODAL_ADD_DASHBOARD = 'modal_add_dashboard';
export const MODAL_ADD_ALERT = 'modal_add_alert';
export const MODAL_IMPORT_VIEWS = 'modal_import_views';

export const IMPORT_VIEW = 'import_view';
export const SHARE_HTML = 'share_html';
export const VIEWS_TAB = 'VIEWS_TAB';
export const DASHBOARDS_VIEW = 'dashboards_view';
